import uniqid from 'uniqid'
import { articles } from '../../portfolio'
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Articles.css'

const Articles = () => {
  if (!articles.length) return null

  return (
    <section id='articles' className='section projects'>
      <h2 className='section__title'>Articles</h2>

      <div className='projects__grid'>
        {articles.map((article) => (
          <ProjectContainer key={uniqid()} article={article} />
        ))}
      </div>
    </section>
  )
}

export default Articles
